export default function WhatWeRoast() {
  return (
    <section className="w-full bg-background-50 py-24 md:py-32 px-6 md:px-10 lg:px-14">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-6 reveal">
          <span className="text-xs tracking-[0.35em] uppercase text-accent-700">What We Roast</span>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl text-primary-950 mt-4 mb-8 leading-tight">
            The same beans we <em>put our name on.</em>
          </h2>
          <p className="text-foreground-800 leading-relaxed mb-6 text-lg">
            There is no separate wholesale coffee here. What arrives at your counter comes off the same
            twelve-kilo drums as everything else we sell: rotating single-origin lots from Ethiopia,
            Colombia and Guatemala, and a house blend built to hold its shape through milk.
          </p>
          <p className="text-foreground-700 leading-relaxed mb-6">
            We visit every farm we buy from and we name the growers on every bag, so your staff can answer
            the question your regulars always ask — where is this from, and who grew it.
          </p>
          <p className="text-foreground-700 leading-relaxed">
            Roasting is to order, in the week you drink it. Nothing waits in a warehouse for a wholesale
            pallet to fill up.
          </p>
        </div>

        <div className="lg:col-span-6 reveal">
          <div className="relative h-[420px] md:h-[560px] w-full overflow-hidden rounded-lg">
            <img
              src={`${import.meta.env.BASE_URL}localized/offering-beans-01.jpg`}
              alt="Freshly roasted single-origin beans"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
